"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleCommentingDialog = void 0;
const react_1 = __importStar(require("react"));
const sort_1 = require("@groupby/enrich-sdk/sort");
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const use_comments_hook_1 = require("./hooks/use-comments.hook");
const partials_1 = require("./partials");
const single_commenting_dialog_styles_1 = require("./single-commenting-dialog.styles");
const partials_2 = require("../partials");
const generic_1 = require("../../../../../generic");
const icons_1 = require("../../../../../icons");
const localization_1 = require("../../../../../localization");
const SingleCommentingDialog = ({ product: { id, proprietaryId, title }, onClose }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { comments, toggleCommentsSorting, createComment, sortOrder, isLoading, isSubmitting, lastCreatedId, } = (0, use_comments_hook_1.useComments)({ productId: id });
    const handleClose = () => onClose(!!lastCreatedId);
    const shouldCommentBeHighlighted = (0, react_1.useCallback)(({ id }, previousComment) => id === previousComment.id && id === lastCreatedId, [lastCreatedId]);
    return (react_1.default.createElement(ui_components_1.Dialog, { open: true, maxWidth: "sm", title: react_1.default.createElement(partials_2.DialogTitle, { title: title, subtitle: proprietaryId, onClose: handleClose }) }, react_1.default.createElement(single_commenting_dialog_styles_1.StyledDialogContent, null, isLoading && react_1.default.createElement(generic_1.SimpleLoading, null), !isLoading && (0, ramda_1.isEmpty)(comments) && (react_1.default.createElement(generic_1.NoDataFallback, { icon: react_1.default.createElement(icons_1.NoCommentsIcon, null), title: t({ key: 'PRODUCT_VIEWER_NO_COMMENTS_HINT' }) })), !isLoading && !(0, ramda_1.isEmpty)(comments) && (react_1.default.createElement(single_commenting_dialog_styles_1.StyledCommentsContainer, null, react_1.default.createElement("div", { className: "comments-container-toolbar" }, react_1.default.createElement(ui_components_1.Typography, { strong: true, color: "primary", variant: "body2" }, t({ key: 'COMMENTS', values: { count: comments.length } })), react_1.default.createElement(single_commenting_dialog_styles_1.StyledButton, { title: t({ key: sortOrder === sort_1.SortDirection.Ascending ? 'SORT_ORDER_OLDEST_FIRST' : 'SORT_ORDER_NEWEST_FIRST' }), endIcon: react_1.default.createElement(icons_1.ArrowUpDownIcon, null), onClick: toggleCommentsSorting })), react_1.default.createElement("div", { className: "comments-container-content" }, comments.map((comment) => (react_1.default.createElement(partials_1.Comment, { shouldCommentBeHighlighted: shouldCommentBeHighlighted, key: comment.id, comment: comment })))))), react_1.default.createElement(partials_2.CommentTextBox, { isSubmitDisabled: isLoading, isSubmitting: isSubmitting, onSubmit: createComment }))));
};
exports.SingleCommentingDialog = SingleCommentingDialog;
